<template>
  <div class="lastArticlesContainer">
    <keep-alive include="WeeklyTourData">
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: "Tours",
}
</script>

<style scoped>

</style>
